export default __webpack_public_path__ + "static/media/profileImg.ae6bd767.png";